import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectAlerts = (state) => get(state, 'alerts', emptyArray);
export const selectIsLoading = (state) => get(state, 'isLoading', false);
export const getSelectedAlertIds = (state) => get(state, 'selectedAlertIds', emptyArray);
export const selectOrdersForShipTogether = (state) => get(state, 'ordersForShipTogether', emptyArray);
export const selectAlertFromAlertId = (state, props) => selectAlerts(state).find((alert) => alert.alertId === props.alertId);
export const getIsLoadingOrders = (state) => get(state, 'isLoadingOrders', false);
